import React from 'react';
import '../Components/Home.css';
import { Link } from 'react-router-dom';
import logo from '../Assets/images/logo.jpg';

const chauffeur = () => {
  return (
    <div className="partner-page">
    
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - Bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Our Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </nav>
          <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
        </div>
      </header>



      <section className="our-services">
                <h2>Car rental</h2>
                <p className="subheading">Explore Our Services Tailored To You</p>
                <div className="service-1">
                    {[
                        {
                            title: "Car rental",
                            desc: "We offer premium car rentals with or without a chauffeur—perfect for business or leisure.",
                            img: require('../Assets/images/car.jpg')
                        }
                      
                    ].map((service, index) => (
                        <div className="service-card" key={index}>
                            <img src={service.img} alt={service.title} />
                            <h3>{service.title}</h3>
                            <p>{service.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
      
      
     

     
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>Luxury chauffeur services across 45,000+ global locations. Precision. Trust. Class.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default chauffeur;